import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectManagementStoreActions,
  ProjectManagementStoreSelectors,
  ProjectManagementStoreReducer,
} from './index';
import { ProjectDto } from '@cradua/data';

@Injectable()
export class ProjectManagementFacade {
  constructor(
    private store: Store<
      ProjectManagementStoreReducer.ProjectManagementPartialState
    >
  ) {}

  projectManagementRecord$ = this.store.select(
    ProjectManagementStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProjectManagementStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProjectManagementStoreSelectors.getProjectManagementError
  );

  getselected() {
    return this.store.select(ProjectManagementStoreSelectors.getSelected);
  }

  get isLoadingProjectManagement() {
    this.store.dispatch(ProjectManagementStoreActions.loadProjectManagement());
    return this.store.select(
      ProjectManagementStoreSelectors.loadingProjectManagement
    );
  }

  get loadProjectManagement() {
    this.store.dispatch(ProjectManagementStoreActions.loadProjectManagement());
    return this.store.select(
      ProjectManagementStoreSelectors.getAllProjectManagement
    );
  }

  searchStudentRecord(query) {
    this.store.dispatch(
      ProjectManagementStoreActions.searchProjectManagementRecord({ query })
    );
  }

  addProjectManagement(newProjectManagement: ProjectDto) {
    this.store.dispatch(
      ProjectManagementStoreActions.addProjectManagement({
        newProjectManagement,
      })
    );
  }

  addProjectSub(newProjectSubManagement: ProjectDto) {
    this.store.dispatch(
      ProjectManagementStoreActions.addProjectSubManagement({
        newProjectSubManagement,
      })
    );
  }
  uploadExcelProjectManagement(uploadExcelRecord: ProjectDto[]) {
    this.store.dispatch(
      ProjectManagementStoreActions.uploadExcelStudentRecord({
        uploadExcelRecord,
      })
    );
  }

  updateProjectManagement(updateProjectManagement: ProjectDto) {
    this.store.dispatch(
      ProjectManagementStoreActions.updateProjectManagement({
        updateProjectManagement,
      })
    );
  }

  removeProjectManagement(ids: any[]) {
    this.store.dispatch(
      ProjectManagementStoreActions.removeProjectManagement({ ids })
    );
  }

  removeProjectStakeholder(ids: any[]) {
    this.store.dispatch(
      ProjectManagementStoreActions.removeProjectManagementStakeholder({ ids })
    );
  }

  removeProjectCluster(ids: any[]) {
    this.store.dispatch(
      ProjectManagementStoreActions.removeProjectManagementCluster({ ids })
    );
  }

  removeProjectReportMaster(ids: any[]) {
    this.store.dispatch(
      ProjectManagementStoreActions.removeProjectManagementReportMaster({ ids })
    );
  }

  removeProjectReportMeeting(ids: any[]) {
    this.store.dispatch(
      ProjectManagementStoreActions.removeProjectManagementReportMeeting({
        ids,
      })
    );
  }

  removeProjectMain(id: string) {
    this.store.dispatch(
      ProjectManagementStoreActions.removeProjectManagementMain({ id })
    );
  }
}
